<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <input type="text" (keyup)="filterContainers($event)">
      <img src="assets/images/close.svg" (click)="close()"/>
    </div>

    <div class="containers">
      @for (container of displayedContainers; track container) {
        <div class="container">
          <div class="logo">
            <img [src]="getCompanyLogo(container.transportcompanyName)"/>
            <a>{{ container.transportcompanyName }}</a>
          </div>
          <div class="info">
            <a>{{ container.containerId }}</a>
            <a>{{ 'CONTAINER.CAPACITY' | translate }}: {{ container.containerMaxCapacity }} {{ mission.volumeUom }}</a>
            <a>{{ 'CONTAINER.PRESSURE' | translate }}: {{ container.containerMAWP | number : '1.0-0' }} {{ mission.pressureUom }}</a>
            <a>{{ 'CONTAINER.EMPTY_TARE' | translate }}: {{ container.containerTareWeight | number : '1.0-0' }} {{ mission.weightUom }}</a>
            @if (container.containerPumpCarrier === 1) {
              <a>{{ 'CONTAINER.PUMP_CARRIER' | translate }}</a>
            }
            <a>{{ 'CONTAINER.MODEL_NAME' | translate }}: {{ container.containermodelName }}</a>
          </div>
          <div class="add" (click)="addContainer(container)">
            <img src="assets/images/add-shopping-cart.svg"/>
          </div>
        </div>
      }
    </div>

  </div>
</div>